// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__11ZN8","label":"Radio_label__gTSjd","checkMark":"Radio_checkMark__XPeUs","disabled":"Radio_disabled__33f8O"};